$(function () {
    'use strict';

    if (typeof ($.fn.masonry) === 'function') {
        $('.shop_categories__wrap').imagesLoaded(function () {
            $('.shop_categories__wrap').masonry({
                horizontalOrder: true,
                fitWidth: true,
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer',
                percentPosition: true
            });
        });
    }
});

